import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { BbidAlreadyExistsBlockComponent } from './bbid-already-exists-block/bbid-already-exists-block.component';
import { BbidNewUserComponent } from './bbid-new-user/bbid-new-user.component';
import { BbidSigninComponent } from './bbid-signin/bbid-signin.component';
import { BlackbaudSsoLogoutPageComponent } from './blackbaud-sso-logout-page/blackbaud-sso-logout-page.component';
import { BlackbaudSsoRedirectComponent } from './blackbaud-sso-redirect/blackbaud-sso-redirect.component';
import { ClientPickerModalComponent } from './client-picker-modal/client-picker.modal.component';
import { LoginExtrasComponent } from './login-extras/login-extras.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { LoginTabsWrapperComponent } from './login-tabs-wrapper/login-tabs-wrapper.component';
import { VerificationCodePageComponent } from './verification-code-page/verification-code-page.component';

@NgModule({
  imports: [
    GCCoreModule
  ],
  declarations: [
    LoginFormComponent,
    LoginExtrasComponent,
    LoginTabsWrapperComponent,
    BlackbaudSsoRedirectComponent,
    BlackbaudSsoLogoutPageComponent,
    VerificationCodePageComponent,
    BbidSigninComponent,
    BbidNewUserComponent,
    BbidAlreadyExistsBlockComponent,
    ClientPickerModalComponent
  ]
})
export class AuthModule { }
